import React from 'react'
import triangleOfTrust from './../../../img/vc_framework/Verifiable-Credentials-Ecosystem-by-MNID-edited.svg'

const Triangle = () => {
    return (
        <div className="vc_section trust_framework_section">

            <div className='inner_div'>
                <img src={triangleOfTrust}  alt="trust-framework" />

                <button className='overlay-button-1 button-primary' onClick={() => window.open('https://dev-web-wallet.mynext.id')}>Wallet</button>
                <button className='overlay-button-2 button-primary' onClick={() => window.open('https://dev-velocert.mynext.id')}>Admin portal</button>
                {/*<button className='overlay-button-3 button-primary' onClick={() => window.open('https://demo-eth.mynext.id/')}>Student portal</button>*/}
                {/*<button className='overlay-button-4 button-primary' onClick={() => window.open('https://docs-velocert.mynext.id/docs/apis/velocert-plugin-api/')}>Issuer API specs</button>*/}
                <button className='overlay-button-5 button-primary' onClick={() => window.open('https://dev-verifier.mynext.id')}>Verifier</button>
                {/*<button className='overlay-button-6 button-primary' onClick={() => window.open('https://issuer.mynext.id/fleet/dashboard')}>verification Admin </button>*/}
                {/*<button className='overlay-button-7 button-primary' onClick={() => window.open('https://test-docs.mynext.id/design/verify/verifiable-credentials')}>Verifier api specs</button>*/}
            </div>
            
        </div>
    )
}

export default Triangle
